import {
  ChangeDetectionStrategy, Component, ContentChildren, Input, QueryList,
} from '@angular/core'
import { FooterIconLinkComponent } from '../footer-icon-link/footer-icon-link.component'

import { RouterOrExternalLinkDirective } from '@knorr-bremse-portals/ngx-components'
import { IconComponent } from '@knorr-bremse-portals/ngx-components/components/icon'

@Component({
  selector: 'nav[kb-footer-icon-link-section]',
  templateUrl: './footer-icon-link-section.component.html',
  styleUrls: ['./footer-icon-link-section.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOrExternalLinkDirective, IconComponent],
})
export class FooterIconLinkSectionComponent {
  @Input({ required: true }) public heading!: string

  @ContentChildren(FooterIconLinkComponent) public iconLinks!: QueryList<FooterIconLinkComponent>
}
